import React from "react";
import { Table, TableHead, TableRow, TableCell } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";

export default function useTableScroll(headCells, opciones) {
  // El segundo argumento tambien se usa historicamente para pasar un filtro.
  // Solo se interpreta como opciones cuando es un objeto.
  const config = opciones && typeof opciones === "object" ? opciones : {};
  const stickyHeader = config.stickyHeader !== false;

  const TblContainer = (props) => (
    <div
      className="table-sm border-table p-0 fixed rounded"
      style={props.container}
    >
      <table className="table table-striped table-hover table-sm">
        {props.children}
      </table>
    </div>
  );

  const TblHead = () => {
    return (
      <thead style={{ border: "none" }}>
        <tr style={{ border: "none" }}>
          {headCells.map((item, index) => (
            <th
              key={index}
              className="letra-tabla-th"
              style={{
                backgroundColor: "rgba(5, 81, 130, 1)",
                fontWeight: "bold",
                width: item.width,
                textAlign: item.textAlign,
                fontSizeAdjust: '0.7',
                zIndex: stickyHeader ? 999 : 'auto',
                ...(stickyHeader ? {} : {
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                }),
                ...(item.style || {}),
              }}
            >
              {item.label}
            </th>
          ))}
        </tr>
      </thead>
    );
  };

  return {
    TblContainer,
    TblHead,
  };
}



// WEBPACK FOOTER //
// ./src/components/useTableScroll.js